module.exports = __webpack_public_path__ + "img/02.3ac816a9.png";